function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.328 9.577c2.245 0 4.114-1.987 4.114-4.533 0-2.481-1.89-4.415-4.114-4.415-2.234 0-4.125 1.955-4.114 4.436 0 2.525 1.869 4.512 4.114 4.512zm-11.773.226c1.944 0 3.588-1.73 3.588-3.943 0-2.17-1.655-3.845-3.588-3.845-1.934 0-3.599 1.708-3.588 3.856 0 2.202 1.633 3.932 3.588 3.932zm-5.576 9.249h7.574c-1.107-1.558.021-4.62 2.374-6.478-1.117-.709-2.568-1.235-4.372-1.235-4.523 0-7.498 3.33-7.498 6.059 0 1.052.515 1.654 1.922 1.654zm11.033 0h12.622c1.708 0 2.288-.537 2.288-1.493 0-2.6-3.33-6.188-8.605-6.188-5.263 0-8.604 3.588-8.604 6.188 0 .956.59 1.493 2.299 1.493z"
});

var SvgTeam = function SvgTeam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/team.ed0d85cc.svg";
export { ForwardRef as ReactComponent };